import getConfig from 'next/config';
import { initialState } from '@/store/reducer';
import useFetch from 'shared/hooks/useFetch';
import { useEffect, useState } from 'react';
import { queryString } from 'shared/util/query';
import type { Filters } from '@/domain';
import { apiListAdImageWrapper } from '@/utils/urlPrepender';

const {
    publicRuntimeConfig: { reactiveApiExternalUrl },
} = getConfig();

export const useSearchResultsWithPricesRegular = (searchId: string, filters: Filters) => {
    const [loading, setLoading] = useState(true);
    const { destination: _unused, booking_from: _unused2, booking_to: _unused3, ...filtersWithoutDestination } = filters;

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 10000);
    }, [searchId, queryString(filtersWithoutDestination)]);
    const { data, error } = useFetch({
        url: `${reactiveApiExternalUrl}/reactive/page/${searchId}${queryString(filtersWithoutDestination)}`,
        options: {
            refreshInterval: () => {
                if (loading) {
                    return 1000;
                }
                return 0;
            },
        },
    });

    return { data: apiListAdImageWrapper(data ?? initialState.results.data), error, loading };
};
